export default {
  getData(state) {
    return state.data;
  },
  getTotal(state) {
    return state.total;
  },
  getVehicleTypes(state) {
    return state.vehicleTypes;
  },
  getVendorCategories(state) {
    return state.vendorCategories;
  },
  getVendorClassification(state) {
    return state.vendorClassification;
  },


  getDetail(state) {
    return state.simpleDetail;
  },

};
